import { type RefObject, useEffect, useMemo } from "react";
import { isProductionEnv } from "@/react/helpers/envHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createRecalculatePositions } from "@circle-react-shared/BuilderUI/Helpers/createRecalculatePositions";
import type { BuilderUIStore } from "@circle-react-shared/BuilderUI/Store";

export const useWindowDebugOptions = (
  store: RefObject<BuilderUIStore | undefined>,
) => {
  const setDropZonePositions = store.current?.getState().setDropZonePositions;

  const recalculatePositions = useMemo(() => {
    if (!setDropZonePositions) return () => {};
    return createRecalculatePositions(setDropZonePositions);
  }, [setDropZonePositions]);

  useEffect(() => {
    if (isProductionEnv() || !store.current) return;
    const storeInstance = store.current;

    const replaceCurrentPage = (block: BaseBlock) => {
      const { updateBlocksFromCurrentPage, removeBlockSelection } =
        storeInstance.getState();
      updateBlocksFromCurrentPage(block);
      removeBlockSelection();
    };

    window.BuilderUI = {
      replaceCurrentPage,
      store: storeInstance,
      recalculateDropZones: recalculatePositions,
    };

    return () => {
      if (window.BuilderUI) {
        delete window.BuilderUI;
      }
    };
  }, [store, recalculatePositions]);
};
